module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="ad-banner"\n     data-promo-title="'+
((__t=(title))==null?'':__t)+
'"\n     data-promo-creative="SerpBanner"\n>\n    <div class="banner-close"\n         data-index="'+
((__t=(hotelIndex))==null?'':__t)+
'"\n         data-banner="'+
((__t=(title))==null?'':__t)+
'">\n        <i class="icon icon-i16_close"></i>\n    </div>\n    <div class="ad-banner__content">\n        <div class="ad-banner__title">'+
((__t=(title))==null?'':__t)+
'</div>\n        <div class="ad-banner__description">'+
((__t=(text))==null?'':__t)+
'\n            ';
 if (link) { 
__p+='\n                ';
 if (link.behaviour === 'copy') { 
__p+='\n                    <div class="tooltip-wrapper">\n                        <div class="tooltip-container">\n                            <div class="tooltip-popover__content tooltip-popover_position-top">\n                                <span class="tooltip-popover__text">\n                                    <div class="tooltip-popover__header">\n                                        Промокод скопирован\n                                    </div>\n                                </span>\n                            </div>\n                        </div>\n                        <a href="#"\n                           class="ad-banner__link js-copy-promo"\n                           data-coupon="'+
((__t=(link.value))==null?'':__t)+
'"\n                           data-behaviour="'+
((__t=(link.behaviour))==null?'':__t)+
'"\n                           onclick="event.preventDefault(); window.copyPromo(this)">\n                            '+
((__t=(link.text))==null?'':__t)+
'\n                        </a>\n                    </div>\n                ';
 } else { 
__p+='\n                    <a href="'+
((__t=(link.value))==null?'':__t)+
'"\n                       class="ad-banner__link"\n                       target="'+
((__t=(link.behaviour === 'openNewPage' ? '_blank' : '_self'))==null?'':__t)+
'"\n                       data-behaviour="'+
((__t=(link.behaviour))==null?'':__t)+
'">\n                        '+
((__t=(link.text))==null?'':__t)+
'\n                    </a>\n                ';
 } 
__p+='\n            ';
 } 
__p+='\n        </div>\n        ';
 if (button) { 
__p+='\n        <div class="ad-banner__button"\n             data-behaviour="'+
((__t=(button.behaviour))==null?'':__t)+
'"\n             data-value="'+
((__t=(button.value))==null?'':__t)+
'"\n        ';
 if (button.behaviour === 'copy') { 
__p+='data-coupon="'+
((__t=(button.value))==null?'':__t)+
'"';
 } 
__p+='>\n        ';
 if (button.behaviour === 'copy') { 
__p+='\n        <span class="button-text">'+
((__t=(button.text))==null?'':__t)+
'</span>\n        <span class="button-text-copied" style="display: none;">\n            <span class="icon-in-circle">\n                <i class="icon icon-i16_check2"></i>\n                </span>\n            <span class="button-text">Промокод скопирован</span>\n            </span>\n        ';
 } else { 
__p+='\n        <a href="'+
((__t=(button.value))==null?'':__t)+
'"\n           class="ad-banner__link--white"\n           target="'+
((__t=(button.behaviour === 'openNewPage' ? '_blank' : '_self'))==null?'':__t)+
'"\n           data-behaviour="'+
((__t=(button.behaviour))==null?'':__t)+
'">\n            '+
((__t=(button.text))==null?'':__t)+
'\n        </a>\n        ';
 } 
__p+='\n    </div>\n    ';
 } 
__p+='\n</div>\n\n<div class="ad-banner__image" style="background-image: url(\''+
((__t=(imageLink))==null?'':__t)+
'\')">\n    <img src="'+
((__t=(imageLink))==null?'':__t)+
'" alt="">\n    ';
 if (adLabel) { 
__p+='\n    <div class="ad-banner__ad-block">\n        <span>Реклама</span>\n        <div class="ad-banner__popover">'+
((__t=(adLabel))==null?'':__t)+
'</div>\n    </div>\n    ';
 } 
__p+='\n</div>\n</div>';
}
return __p;
};
